import React from 'react'
import './Securite.css';

const Securite: React.FC = () => {
    return (
        <div className="securite-page">
            <div className="securite-custom-container">
                <h1 className="securite-custom-title-h1">Politique de Sécurité et de Protection des Données de Centralis</h1>
                <h2 className="securite-custom-title-h2">Mise à jour le 17 juin 2025</h2>

                <h3 className="securite-custom-title-h3">Préambule</h3>
                <p className="securite-custom-paragraph">
                    Centralis, association loi 1901 d'intérêt général, centrale nationale d'achats publics dédiée à la rénovation du patrimoine, attache une importance essentielle à la sécurité des systèmes d'information et à la protection des données à caractère personnel.
                </p>
                <p className="securite-custom-paragraph">
                    La présente politique définit les principes et les mesures mis en œuvre pour garantir la confidentialité, l'intégrité, la disponibilité et la conformité réglementaire des données traitées dans le cadre des activités de Centralis.
                </p>

                <h3 className="securite-custom-title-h3">1. Principes généraux</h3>
                <p className="securite-custom-paragraph">
                    Centralis s'engage à :
                </p>
                <ul className="securite-custom-ul">
                    <li>Respecter les obligations du Règlement général sur la protection des données (RGPD - Règlement (UE) 2016/679) et de la loi Informatique et Libertés.</li>
                    <li>Garantir un niveau de sécurité adapté à la nature des données traitées.</li>
                    <li>Sensibiliser et responsabiliser l'ensemble des membres, salariés, bénévoles et prestataires.</li>
                    <li>Documenter et tracer l'ensemble des traitements de données à caractère personnel.</li>
                </ul>

                <h3 className="securite-custom-title-h3">2. Gouvernance des données et des risques</h3>
                <ul className="securite-custom-ul">
                    <li>Un Référent Sécurité et Données est désigné en interne pour coordonner l'application de la présente politique.</li>
                    <li>Le cas échéant, un Délégué à la Protection des Données (DPO) est désigné et ses coordonnées sont diffusées à tous les adhérents et partenaires.</li>
                    <li>Une cartographie des risques liés à la sécurité informatique et aux traitements de données est tenue à jour.</li>
                    <li>Des audits internes et/ou externes peuvent être réalisés pour contrôler l'application des règles de sécurité.</li>
                </ul>

                <h3 className="securite-custom-title-h3">3. Sécurité des systèmes d'information</h3>
                <p className="securite-custom-paragraph">
                    Centralis met en œuvre des mesures techniques et organisationnelles proportionnées :
                </p>
                <ul className="securite-custom-ul">
                    <li>Hébergement sécurisé des données sur des serveurs privés situés en France.</li>
                    <li>Sauvegardes régulières (mensuelles au minimum) avec test de restauration.</li>
                    <li>Accès restreint aux données selon des profils d'habilitation définis.</li>
                    <li>Mise à jour régulière des systèmes et antivirus.</li>
                    <li>Accès protégé par authentification forte pour les administrateurs.</li>
                    <li>Chiffrement des communications et, lorsque nécessaire, des données stockées.</li>
                    <li>Journalisation des connexions et des actions sensibles.</li>
                </ul>

                <h3 className="securite-custom-title-h3">4. Conformité RGPD des traitements de données personnelles</h3>
                <h4 className="securite-custom-title-h4">4.1. Finalités des traitements</h4>
                <p className="securite-custom-paragraph">
                    Centralis traite des données à caractère personnel exclusivement pour l'exécution de ses missions :
                </p>
                <ul className="securite-custom-ul">
                    <li>Gestion des membres et des utilisateurs de la plateforme.</li>
                    <li>Passation et exécution des marchés publics.</li>
                    <li>Suivi des appels d'offres, des candidatures et des fournisseurs.</li>
                    <li>Communication institutionnelle et envoi d'informations.</li>
                </ul>

                <h4 className="securite-custom-title-h4">4.2. Registre des traitements</h4>
                <p className="securite-custom-paragraph">
                    Un registre des traitements est tenu à jour conformément à l'article 30 du RGPD.
                </p>

                <h4 className="securite-custom-title-h4">4.3. Droits des personnes</h4>
                <p className="securite-custom-paragraph">
                    Centralis garantit l'exercice des droits des personnes concernées (accès, rectification, effacement, opposition, limitation, portabilité, opposition à la prise de décision automatisée).
                </p>
                <p className="securite-custom-paragraph">
                    Les demandes doivent être adressées à : contact@centralis.site
                </p>

                <h3 className="securite-custom-title-h3">5. Relations avec les sous-traitants</h3>
                <p className="securite-custom-paragraph">
                    Tout prestataire ou sous-traitant accédant à des données à caractère personnel dans le cadre d'un marché public avec Centralis :
                </p>
                <ul className="securite-custom-ul">
                    <li>Est soumis à un engagement contractuel de conformité RGPD, figurant dans les pièces du marché.</li>
                    <li>Ne peut traiter les données que sur instruction de Centralis.</li>
                    <li>S'engage à appliquer des mesures de sécurité strictes et à tenir un registre des sous-traitances ultérieures.</li>
                    <li>A l'obligation de notifier toute violation de données à contact@centralis.site dans un délai de 48h.</li>
                    <li>Doit garantir la destruction ou la restitution des données à l'issue du contrat.</li>
                </ul>

                <h3 className="securite-custom-title-h3">6. Gestion des incidents de sécurité</h3>
                <p className="securite-custom-paragraph">
                    En cas de suspicion d'incident :
                </p>
                <ul className="securite-custom-ul">
                    <li>Un processus de déclaration interne est déclenché.</li>
                    <li>Une analyse des causes, impacts et mesures correctives est réalisée.</li>
                </ul>
                <p className="securite-custom-paragraph">
                    Si la violation de données présente un risque pour les droits et libertés des personnes concernées, Centralis :
                </p>
                <ul className="securite-custom-ul">
                    <li>Notifie la CNIL dans un délai de 72h.</li>
                    <li>Informe les personnes concernées dans les meilleurs délais, si nécessaire.</li>
                </ul>

                <h3 className="securite-custom-title-h3">7. Sensibilisation et formation</h3>
                <p className="securite-custom-paragraph">
                    Centralis forme ses administrateurs, bénévoles et salariés à la sécurité des systèmes d'information et aux bonnes pratiques en matière de protection des données :
                </p>
                <ul className="securite-custom-ul">
                    <li>Sessions de sensibilisation annuelles.</li>
                    <li>Guides pratiques de gestion des données personnelles.</li>
                    <li>Intégration de la sécurité dans les formations relatives à la commande publique.</li>
                </ul>

                <h3 className="securite-custom-title-h3">8. Révision et mise à jour</h3>
                <p className="securite-custom-paragraph">
                    Cette politique est évaluée annuellement et peut être révisée en fonction :
                </p>
                <ul className="securite-custom-ul">
                    <li>Des évolutions réglementaires (RGPD, directives européennes…),</li>
                    <li>Des modifications de l'organisation ou de ses systèmes,</li>
                    <li>Des retours d'expérience ou audits.</li>
                </ul>

                <h3 className="securite-custom-title-h3">Conclusion</h3>
                <p className="securite-custom-paragraph">
                    Par cette politique, Centralis réaffirme son engagement fort en faveur de la sécurité numérique, de la conformité réglementaire et du respect des droits fondamentaux. Toutes les parties prenantes – membres, prestataires, partenaires – sont appelées à en respecter les principes dans l'exercice de leurs fonctions ou missions.
                </p>
            </div>
        </div>
    )
}

export default Securite